module.exports = __webpack_public_path__ + "img/27.f57c381d.jpg";